import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import Config from 'root/globals/Config';
import Components from 'root/Components';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { View, Text, Image } from 'react-native';
import { Button } from 'root/globals/Elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentDialog } from 'root/globals/Dialog';
import Iframe from 'react-iframe';

import defaults from 'root/globals/Defaults.less';
import document_view from './Document View.less';

const styles = {...defaults, ...document_view};

export default class DocumentDialog extends CustomComponent {
    componentDidMount(){
        if(this.props.document.secured == 't')
            this.set_timeout = setTimeout(() => {
                this.props.parent.props.onUnauthenticated();
            }, 300000);
    }
    
    componentWillUnmount() {
        clearTimeout(this.set_timeout);
    }
    
    _onClose(){
        this.props.parent.setState({show_document_dialog: false})
    }
    
    render(){
        let isPDF   = (_.get_file_extension(this.props.document[_.if_empty(this.props.document.field, 'file')]) == 'pdf');
        let src     = Config.IMAGES_URL + 'file-' + this.props.document.component_id + '-' + this.props.document.id + '-' + _.if_empty(this.props.document.field, 'file') + '.' + (isPDF ? 'pdf' : 'png');

        if(this.props.document.secured == 'f' || this.props.document.component_id == Components.__CUSTOMER_DOCUMENT_COMPONENT__ || (this.props.document.secured == 't' && this.props.parent.props.authenticated))
            return(
                <ContentDialog 
                    open={this.props.parent.state.show_document_dialog}
                    onClose={this._onClose}
                    title={ <View className={['d-flex flex-row align-items-center']}>
                                <Text>{this.props.document.title}</Text>
                                {(this.props.document.secured == 't' && <FontAwesomeIcon icon={faLock} className={['fa-fw ml-2', styles['color-red-pink'], styles['f-1-5']].join(' ')}/>)}
                            </View>}
                    fullWidth={true}
                    actions={<Button onPress={this._onClose}>Sluiten</Button>}>
                    <View className={['mh-100 w-100']}>
                       {(isPDF ?
                        <Iframe url={src}
                            width="100%"
                            height="640px"
                            scrolling="false"
                            className={['border-0', styles['iframe']].join(' ')}
                            position="relative"/>
                        : <Image source={src} native={true} className={['w-100']}/>)}
                    </View>
                </ContentDialog>
            );
        
        return null;
    }
}